import ElementPage from "../Elements";
import { Link, NavLink } from "react-router-dom";
import { Card, Col, Container, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import { getOurServiceList } from "./MeldiDhamCRUD";
import { useTranslation } from "react-i18next";

function OurServicePage() {
  const { t, i18n } = useTranslation();
  const [services, setServices] = useState([]);
  const mainURL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServices = async () => {
    try {
      const res = await getOurServiceList();
      // console.log("res.isSuccess", res.data.isSuccess);
      if (res.data.isSuccess) {
        const filtered = res.data.responseObject.filter(
          (service) => service.isActive === true,
        );
        console.log("filtered", filtered);
        setServices(filtered);
      }
      console.log("res", res);
    } catch (error) {
      console.error("Error fetching services:", error);
    }
  };

  const getLocalized = (item, field) => {
    if (!item) return "";
    const lang = i18n.language;
    if (lang === "gu") return item[`${field}_GJ`] || item[field];
    if (lang === "hi") return item[`${field}_HN`] || item[field];
    return item[field]; // default EN
  };

  return (
    <>
      {" "}
      <div
        className="container mb-10 px-4 py-4"
        role="navigation"
        aria-label="Breadcrumb"
        // style={{ marginTop: "var(--header-height)" }}
      >
        <div className="d-flex align-items-center gap-2 py-2">
          <NavLink
            to="/"
            className="site-button"
            style={{ fontSize: "17px", color: "#000000" }}
          >
            {t("menu.home")} &gt;&gt;
          </NavLink>

          <span className="text-[#4c934c]" style={{ fontSize: "17px" }}>
            {t("menu.services", "Our Services")}
          </span>
        </div>
        {/* <div className="section-full py-7">
          <div className="section-full mt-5 "> */}
        {/* <div className="container py-3">
              <div className="row ">
                <div className="col-lg-7 col-md-6">
                  <img
                    className="img-fluid"
                    src="/assets/img/istockphoto-1127447341-612x612.jpg"
                    width={600}
                    height={15}
                    alt="img"
                  />
                </div>
                <div className="col-lg-5 col-md-6">
                  <div className="sx-shipment-wrap">
                    <div className="mt-box m-b30">
                      <div className="row-container text-black">
                        <h3
                          style={{
                            fontWeight: "bold",
                            fontSize: "2.5rem",
                            textAlign: "center",
                            // color: "#123456",
                            textDecoration: "uppercase",
                            letterSpacing: "0.1rem",
                          }}
                          className="text-center mb-4 text-blue-900 headting-title"
                        >
                          Our Services
                        </h3>
                        <div className="mt-separator-outer m-b30">
                          <div className="mt-separator bg-warning  m-t25 m-b30" />
                        </div>
                      </div>
                      <p
                        className="fs-6 m-t80 mb-2color-[#003459]"
                        style={{
                          fontWeight: "450",
                          fontSize: 17,
                          textAlign: "justify",
                        }}
                      >
                        <strong>
                          {" "}
                          At Ecobuild Contractors & Developers Pvt. Ltd.
                        </strong>{" "}
                        we offer a comprehensive suite of civil engineering and
                        infrastructure development services, designed to meet
                        the evolving needs of industrial, commercial, and urban
                        development projects. With a commitment to innovation,
                        safety, and sustainability, our services are backed by
                        decades of experience, advanced technology, and a
                        dedicated team of engineering professionals.
                     
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>{" "} */}
        <section className="">
          <Container className="">
            <h5 className="text-center mb-4 text-green-700 headting-title">
              {t("services.title", "Our Services")}
            </h5>
            <Row>
              {services.map((service) => (
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  className="mb-1"
                  key={service.serviceID}
                >
                  <Card className="h-100 shadow-sm">
                    <Card.Img
                      variant="top"
                      src={`${mainURL + service.servicePhotoPath}`}
                      alt={service.serviceName}
                      style={{ height: "250px", objectFit: "cover" }}
                      className="mb-2"
                    />
                    <Card.Body className="d-flex flex-column ps-2">
                      <Card.Title className="font-serif fw-bold text-gray-900 headting-title fs-5 mb-2 mt-2">
                        {getLocalized(service, "serviceName")}
                      </Card.Title>
                      <hr className="px-1 mb-1" />
                      <div
                        className="text-secondary flex-grow-1 font-serif"
                        style={{
                          display: "-webkit-box",
                          WebkitLineClamp: 3,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          //   fontFamily: "Arial, sans-serif",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: getLocalized(service, "description"),
                        }}
                      />

                      <div className="mt-2 text-center text-green-700">
                        <Link
                          to={`/page/service/${service.ourServiceID}`}
                          className="fw-bold"
                        >
                          Read More
                          <i className="bi bi-arrow-right-short ms-1"></i>
                        </Link>
                        {/* <i className="bi bi-arrow-right-short ms-1"></i> */}
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
        {/* </div>
        </div> */}
      </div>
      <ElementPage />
    </>
  );
}
export default OurServicePage;
